import { useEffect, useState } from 'react';
import './style.scss';
import { SearchNav } from 'views/components/organisms/searchNav';
import { Pagination } from 'views/components/atoms/pagination';
import { GetSymbolListQueryVariables } from 'views/utils/graphql/graphql';
import { useGetSymbolList } from './hooks/useGetSymbolList';
import { createListProductCard } from './function/createListProductCard';
import { calcTotalPage } from 'views/utils/calc/pagination';
import { PageLocationSP } from 'views/components/atoms/pageLocation';
import { Loading } from 'views/components/atoms/loading';

const PAGE_COUNT = 30;

const initialSymbolListVariables: GetSymbolListQueryVariables = {
  count: PAGE_COUNT,
  page: 1,
  symbolName: '',
};

export const ProductList = () => {
  const {
    symbolName,
    setSymbolName,
    currentPage,
    setCurrentPage,
    setSymbolNameWithFetch,
    getSymbolListState,
    showLoading,
  } = useGetSymbolList(initialSymbolListVariables);

  return (
    <section className="outletWrapper">
      <div className="centerContent">
        <PageLocationSP />
        {/* 検索欄 */}
        <SearchNav
          searchWord={symbolName}
          setSearchWord={setSymbolName}
          submitSearch={setSymbolNameWithFetch}
          clearSearch={() => setSymbolNameWithFetch('')}
          placeholder="銘柄名"
        />
        {/* 銘柄リスト */}
        <div className="productListWrapper">
          {showLoading && (
            <div className="loadingWrapper">
              <Loading />
            </div>
          )}
          {getSymbolListState.data && createListProductCard(getSymbolListState.data)}
        </div>
        {/* ページネーション */}
        <Pagination
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          pageCount={calcTotalPage(
            getSymbolListState.data?.GetSymbolList?.TotalCount ? getSymbolListState.data?.GetSymbolList?.TotalCount : 1,
            PAGE_COUNT,
          )}
          fetchApi={() => {}} // useGetSymbolList内で行うためここでは何もしない
        />
      </div>
    </section>
  );
};
